export const MARKET_STATS_BAR_CELL_CLASSNAME =
	'flex flex-col justify-center px-sm xl:px-md';

export const MARKET_STATS_BAR_CELL_LABEL_CLASSNAME =
	'md:mb-1 typo-body-2xs md:typo-body-xs text-text-secondary underline decoration-dotted underline-offset-[20%] decoration-text-secondary';

// Same as the label classname above but without the dotted underline, for stats
// labels that have no tooltip on hover.
export const MARKET_STATS_BAR_CELL_LABEL_NO_UNDERLINE_CLASSNAME =
	'md:mb-1 typo-body-2xs md:typo-body-xs text-text-secondary';

export const MARKET_STATS_BAR_CELL_VALUE_CLASSNAME =
	'typo-label-sm text-text-default';

export const MARKET_STATS_BAR_CELL_VALUE_SKELETON_CLASSNAME =
	'w-full xs:my-[0.5px] xs:h-md sm:my-2xs sm:h-[14px]';
